import { createContext, useContext, useState } from "react";
import { Beneficiary } from "../models/Beneficiary";
import { Disbursement } from "../models/Disbursement";

type PaymentTransactionContextType = {
  buyCurrency: string,
  setBuyCurrency: React.Dispatch<React.SetStateAction<string>>,
  buyCurrencyInfo: any,
  setBuyCurrencyInfo: React.Dispatch<React.SetStateAction<any>>,
  sellCurrency: string,
  setSellCurrency: React.Dispatch<React.SetStateAction<string>>,
  setSellCurrencyInfo: React.Dispatch<React.SetStateAction<any>>,
  sellCurrencyInfo: any,
  lockedSide: string,
  setLockedSide: React.Dispatch<React.SetStateAction<string>>,
  settlementMethod: string,
  setSettlementMethod: React.Dispatch<React.SetStateAction<string>>,
  beneficiaries: Beneficiary[],
  setBeneficiaries: React.Dispatch<React.SetStateAction<Beneficiary[]>>,
  disbursements: Disbursement[],
  setDisbursements: React.Dispatch<React.SetStateAction<Disbursement[]>>,
  disbursementInfoAsParameter: boolean,
  setDisbursementInfoAsParameter: React.Dispatch<React.SetStateAction<boolean>>,
  fromBalances: boolean,
  setFromBalances: React.Dispatch<React.SetStateAction<boolean>>
  validateInput: boolean,
  setValidateInput: React.Dispatch<React.SetStateAction<boolean>>,
  totalPayment: number,
  setTotalPayment: React.Dispatch<React.SetStateAction<number>>,
  totalSettlement: number,
  setTotalSettlement: React.Dispatch<React.SetStateAction<number>>,
  totalFees: number,
  setTotalFees: React.Dispatch<React.SetStateAction<number>>,
  valueDate: string,
  setValueDate: React.Dispatch<React.SetStateAction<string>>,
  customerRate: number,
  setCustomerRate: React.Dispatch<React.SetStateAction<number>>,
  quoted: boolean,
  setQuoted: React.Dispatch<React.SetStateAction<boolean>>,
  dealHeaderId: number,
  setDealHeaderId: React.Dispatch<React.SetStateAction<number>>,
  disbursementsHasChanged: boolean,
  setDisbursementHasChanged: React.Dispatch<React.SetStateAction<boolean>>
}

const PaymentTransactionContext = createContext<PaymentTransactionContextType | undefined>(undefined)

export const PaymentTransactionContextProvider = ({ children }: any) => {

  const [buyCurrency, setBuyCurrency] = useState('')
  const [buyCurrencyInfo, setBuyCurrencyInfo] = useState({})
  const [sellCurrency, setSellCurrency] = useState('')
  const [sellCurrencyInfo, setSellCurrencyInfo] = useState({})
  const [lockedSide, setLockedSide] = useState('buy')
  const [settlementMethod, setSettlementMethod] = useState('')
  const [beneficiaries, setBeneficiaries] = useState<Beneficiary[]>([])
  const [disbursements, setDisbursements] = useState<Disbursement[]>([])
  const [disbursementInfoAsParameter, setDisbursementInfoAsParameter] = useState(false)
  const [fromBalances, setFromBalances] = useState(false)
  const [validateInput, setValidateInput] = useState(false)
  const [totalPayment, setTotalPayment] = useState(0)
  const [totalSettlement, setTotalSettlement] = useState(0)
  const [totalFees, setTotalFees] = useState(0)
  const [valueDate, setValueDate] = useState('')
  const [customerRate, setCustomerRate] = useState(0)
  const [quoted, setQuoted] = useState(false)
  const [dealHeaderId, setDealHeaderId] = useState(0)
  const [disbursementsHasChanged, setDisbursementHasChanged] = useState(false)

  return <PaymentTransactionContext.Provider value={{
    buyCurrency, setBuyCurrency,
    buyCurrencyInfo, setBuyCurrencyInfo,
    sellCurrency, setSellCurrency,
    sellCurrencyInfo, setSellCurrencyInfo,
    lockedSide, setLockedSide,
    settlementMethod, setSettlementMethod,
    beneficiaries, setBeneficiaries,
    disbursements, setDisbursements,
    disbursementInfoAsParameter, setDisbursementInfoAsParameter,
    fromBalances, setFromBalances,
    validateInput, setValidateInput,
    totalPayment, setTotalPayment,
    totalSettlement, setTotalSettlement,
    totalFees, setTotalFees,
    valueDate, setValueDate,
    customerRate, setCustomerRate,
    quoted, setQuoted,
    dealHeaderId, setDealHeaderId,
    disbursementsHasChanged, setDisbursementHasChanged
  }}>
    {children}
  </PaymentTransactionContext.Provider>

};

export const usePaymentTransactionContext = () => {
  const context = useContext(PaymentTransactionContext);
  if (!context) {
    throw new Error('usePaymentTransactionContext must be used within a PaymentTransactionContextProvider');
  }
  return context;
};